enum BlogAnalyticEventType {
    BlogView = 1,
    PhoneClicked = 2,
    EmailClicked = 3,
    WebsiteClicked = 4
}

export default BlogAnalyticEventType
